/**
 * Builds an SVG marker for engine state plot lines in Highcharts.
 *
 * NOTE: Inline styles are used here intentionally because this generates
 * an HTML string for Highcharts plot line labels (not a React component).
 * Highcharts injects this directly into the DOM, so styled-components
 * cannot be used in this context.
 */
export const buildEngineStateMarkerSvg = (accentColor: string, bgColor: string, fadeColor: string): string => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="38" viewBox="0 0 12 38" fill="none">
<circle cx="6" cy="19.5" r="6" fill="${bgColor}"/>
<path d="M6 1.5L6 36.5" stroke="url(#grad0)" stroke-width="3" stroke-linecap="round"/>
<path d="M6 1.5L6 36.5" stroke="url(#grad1)" stroke-linecap="round" stroke-dasharray="2 2"/>
<circle cx="6" cy="19.5" r="3.5" fill="${bgColor}" stroke="${accentColor}"/>
<defs>
<linearGradient id="grad0" x1="5.5" y1="1.5" x2="5.5" y2="36.5" gradientUnits="userSpaceOnUse">
<stop stop-color="${bgColor}"/>
<stop offset="1" stop-color="${bgColor}" stop-opacity="0"/>
</linearGradient>
<linearGradient id="grad1" x1="6" y1="1.5" x2="6" y2="36.7465" gradientUnits="userSpaceOnUse">
<stop offset="0.1" stop-color="${bgColor}"/>
<stop offset="0.5" stop-color="${accentColor}"/>
<stop offset="0.9" stop-color="${fadeColor}" stop-opacity="0.5"/>
</linearGradient>
</defs>
</svg>`;

  const dataUri = `data:image/svg+xml,${encodeURIComponent(svg)}`;

  return `<div style="width:12px;height:38px;background-image:url('${dataUri}');background-size:contain;background-repeat:no-repeat;"></div>`;
};
